import React, { FC, Fragment, ReactDOM, useRef, useState } from 'react';

import cn from 'classnames';
import dayjs from 'dayjs'
import $ from 'jquery';

import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'

import { updateDuo } from './countdown';

import styles from './index.module.less';

interface TimeProps {
  endTime: number,
  id: string,
  className?: string
}
export const CardDown:FC<TimeProps> = (props) => {
  const { endTime, className, id } = props;
  const timeRef = useRef(null);
  const [hours, setHours] = useState(Math.floor((endTime - dayjs().unix()) / (60 * 60)));
  const tick = (time:number, positions:ReactDOM) => {
    const hours = 60 * 60;
    const minutes = 60;
    let left = time - dayjs().unix();
    if (left < 0) {
      left = 0;
      clearTimeout(timeRef.current);
    } else {
      const h = Math.floor(left / hours);
      setHours(h);
      updateDuo(0, 2, h, positions);
      left -= h * hours;
      // Number of minutes left
      const m = Math.floor(left / minutes);
      updateDuo(3, 4, m, positions)
      left -= m * minutes;
      // Number of seconds left
      const s = left;
      updateDuo(5, 6, s, positions)
      timeRef.current = setTimeout(tick, 1000, time, positions);
    }
  };
  useIsomorphicLayoutEffect(() => {
    endTime && tick(endTime, $(`#${id}`).find('.position'))
    return () => {
      clearTimeout(timeRef.current);
    }
  }, [endTime])
  return (
    <Fragment>
      <div id={id} className={cn(styles.countdownHolder, className)}>
        <span className={cn(styles.countHours)}>
          <span className={cn(styles.position, 'position', {
            [styles.longHours]: hours < 100
          })}>
            <span className={cn(styles.digit, 'DINPro', 'digit static')}>0</span>
          </span>
          <span className={cn(styles.position, 'position')}>
            <span className={cn(styles.digit, 'DINPro', 'digit static')}>0</span>
          </span>
          <span className={cn(styles.position, 'position')}>
            <span className={cn(styles.digit, 'DINPro', 'digit static')}>0</span>
          </span>
        </span>
        <span className={styles.countDiv}></span>
        <span className={styles.countMinutes}>
          <span className={cn(styles.position, 'position')}>
            <span className={cn(styles.digit, 'DINPro', 'digit static')}>0</span>
          </span>
          <span className={cn(styles.position, 'position')}>
            <span className={cn(styles.digit, 'DINPro', 'digit static')}>0</span>
          </span>
        </span>
        <span className={styles.countDiv}></span>
        <span className={styles.countSeconds}>
          <span className={cn(styles.position, 'position')}>
            <span className={cn(styles.digit, 'DINPro', 'digit static')}>0</span>
          </span>
          <span className={cn(styles.position, 'position')}>
            <span className={cn(styles.digit, 'DINPro', 'digit static')}>0</span>
          </span>
        </span>
      </div>
    </Fragment>
  );
};
